import { render, staticRenderFns } from "./DimissioniProtettePazientiList.vue?vue&type=template&id=120dc098"
import script from "./DimissioniProtettePazientiList.vue?vue&type=script&lang=js"
export * from "./DimissioniProtettePazientiList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports